import type { ReactElement, ReactNode } from 'react';
import {
  AdminIcon, AiAgentIcon, BookOpenIcon, BriefcaseIcon, CadIcon, CalendarIcon, ChartColumnIcon, ChartPieIcon,
  CpuIcon, FileStackIcon, GaugeIcon, LogisticsIcon, MessageSquareIcon, MonitorIcon, PortfolioIcon,
} from '@utils/icons';
import { LOCAL_FALLBACK, recolor, type ICardIconName } from '@components/Pages/AnalyticsPage/cardIconAssets';
import styles from './helpIcons.module.css';

// Each guide shows the icon its page uses in the app (spec ruling 4). Report
// guides use the Analytics report cards' own (vendored) icons.
const NAV_ICONS: Record<string, (size: number) => ReactNode> = {
  briefcase: (size) => <BriefcaseIcon size={size} />,
  dashboard: (size) => <PortfolioIcon size={size} />,
  monitor: (size) => <MonitorIcon size={size} />,
  calendar: (size) => <CalendarIcon size={size} />,
  comms: (size) => <MessageSquareIcon size={size} />,
  scheduler: (size) => <ChartColumnIcon size={size} />,
  logistics: (size) => <LogisticsIcon size={size} />,
  cpu: (size) => <CpuIcon size={size} />,
  cad: (size) => <CadIcon size={size} />,
  filestack: (size) => <FileStackIcon size={size} />,
  chartpie: (size) => <ChartPieIcon size={size} />,
  gauge: (size) => <GaugeIcon size={size} />,
  aiagent: (size) => <AiAgentIcon size={size} />,
  admin: (size) => <AdminIcon size={size} />,
};

const REPORT_ICONS: Record<string, ICardIconName> = {
  'report-clipboard': 'clipboard',
  'report-helmet': 'helmet',
  'report-clock': 'clock',
  'report-calendar-plus': 'calendar-plus',
  'report-route': 'Route',
  'report-pin': 'pin',
};

interface IHelpGuideIconProps {
  iconKey: string;
  size?: number;
}

export function HelpGuideIcon({ iconKey, size = 16 }: IHelpGuideIconProps): ReactElement {
  const report = REPORT_ICONS[iconKey];
  if (report) {
    return (
      <span
        className={styles.raw}
        style={{ width: size, height: size }}
        aria-hidden="true"
        // Vendored local SVG assets, not user content.
        dangerouslySetInnerHTML={{ __html: recolor(LOCAL_FALLBACK[report]) }}
      />
    );
  }
  const nav = NAV_ICONS[iconKey];
  return <>{nav ? nav(size) : <BookOpenIcon size={size} />}</>;
}
